import React, { ReactElement } from 'react'

import poweredByDistribusionImage from '@images/common/powered-by-distribusion.svg'
import { useTranslation } from '@lib/i18n'

import '@components/Logo/index.scss'

const PoweredByDistribusion = (): ReactElement | null => {
  const { t } = useTranslation()
  return (
    <img
      className="powered-by-distribusion-image"
      src={poweredByDistribusionImage}
      alt={t('accessibility.images.distribusionLogo')}
    />
  )
}

export default PoweredByDistribusion
